import { getPoiEntityStatusDefinition } from './entityStatus';
import type { PoiEntityStatus } from './entityStatus';
import {
    formatPipeType,
    formatRepaired,
    formatSearchDate,
    getLeakageRateDisplay,
    formatLeakageRateMlD,
} from './poiFeatureProperties';
import type { PoiFeatureProperties } from './poiFeatureProperties';

const EMPTY = '—';

/** Returns `—` for null, undefined, or empty string; otherwise stringifies the value. */
export function fmt(value: string | number | null | undefined): string {
    if (value === null || value === undefined || value === '') return EMPTY;
    return String(value);
}

/**
 * Builds the plain-text clipboard string for a selected POI.
 * @param coords - GeoJSON coordinate pair [longitude, latitude].
 */
export function buildPoiClipboardText(poi: PoiFeatureProperties, coords?: [number, number] | null): string {
    const leakage = getLeakageRateDisplay(poi);
    return [
        'Point of Interest',
        '',
        `Worklist: ${fmt(poi.name)}`,
        `Stop: ${fmt(poi.stop)}`,
        // The same registry label the status pill shows — the copied text mirrors the panel.
        `Status: ${getPoiEntityStatusDefinition(poi.status as PoiEntityStatus).label}`,
        `Point of Interest What3words: ${fmt(poi.what3words)}`,
        `Leak What3words: ${fmt(poi.leak_what3words)}`,
        `Pipe Type: ${fmt(formatPipeType(poi.pipe_type))}`,
        `Leakage Rate: Ml/D ${formatLeakageRateMlD(leakage.value)}`,
        `Date of Search: ${fmt(formatSearchDate(poi.search_date))}`,
        `Repaired: ${fmt(formatRepaired(poi.repaired))}`,
        `Latitude: ${coords != null ? fmt(coords[1]) : EMPTY}`,
        `Longitude: ${coords != null ? fmt(coords[0]) : EMPTY}`,
    ].join('\n');
}
